import { v4 as uuidv4 } from "uuid";
import config from "../config";

export interface NhsLoginInfo {
  authUrl: string;
  state: string;
  nonce: string;
}

export const authScopes = [
  "openid",
  "profile",
  "email",
  "phone",
  "gp_integration_credentials",
  "profile_extended"
];

export const getNHSLoginAuthInfo = (): NhsLoginInfo => {
  const state = uuidv4();
  const nonce = uuidv4();

  const scopes = authScopes.join("+");
  const authUrl = `${config.NHS_LOGIN_ISSUER}/authorize?response_type=code&client_id=${config.NHS_LOGIN_CLIENT_ID}&state=${state}&nonce=${nonce}&scope=${scopes}&redirect_uri=${config.NHS_LOGIN_REDIRECT_URL}`;

  return {
    authUrl,
    state,
    nonce
  };
};
